function initProductCarousel(panel) {
  const container = panel.querySelector(".rbsv4-product-carousel__carousel");
  const nav = panel.querySelector(".rbsv4-product-carousel__nav");
  const prevBtn = panel.querySelector(".rbsv4-product-carousel__nav-btn--prev");
  const nextBtn = panel.querySelector(".rbsv4-product-carousel__nav-btn--next");
  const dotsContainer = panel.querySelector(".rbsv4-product-carousel__nav-dots");
  if (!container || !prevBtn || !nextBtn) return { refresh() {}, isVisible: () => false };

  function getPageSize() {
    return container.clientWidth;
  }

  function getMaxScroll() {
    return container.scrollWidth - container.clientWidth;
  }

  function getNumPages() {
    const maxScroll = getMaxScroll();
    if (maxScroll <= 0) return 1;
    return Math.ceil(maxScroll / getPageSize()) + 1;
  }

  function getCurrentPage() {
    const maxScroll = getMaxScroll();
    if (container.scrollLeft >= maxScroll - 1) return getNumPages() - 1;
    return Math.round(container.scrollLeft / getPageSize());
  }

  function updateNavVisibility() {
    if (!nav) return;
    if (getMaxScroll() <= 1) {
      nav.setAttribute("data-nav-hidden", "");
    } else {
      nav.removeAttribute("data-nav-hidden");
    }
  }

  function buildDots() {
    if (!dotsContainer) return;
    dotsContainer.innerHTML = "";
    const numPages = getNumPages();
    for (let i = 0; i < numPages; i++) {
      const dot = document.createElement("button");
      dot.classList.add("rbsv4-product-carousel__nav-dot");
      dot.setAttribute("aria-label", `Go to page ${i + 1}`);
      dot.addEventListener("click", () => {
        const targetScroll = i === getNumPages() - 1 ? getMaxScroll() : i * getPageSize();
        container.scrollTo({ left: targetScroll, behavior: "smooth" });
      });
      dotsContainer.appendChild(dot);
    }
  }

  function updateButtons() {
    const atStart = container.scrollLeft <= 1;
    const atEnd = container.scrollLeft >= getMaxScroll() - 1;
    prevBtn.classList.toggle("active", !atStart);
    nextBtn.classList.toggle("active", !atEnd);
  }

  function updateDots() {
    if (!dotsContainer) return;
    const dots = dotsContainer.querySelectorAll(".rbsv4-product-carousel__nav-dot");
    const currentPage = getCurrentPage();
    dots.forEach((dot, i) => dot.classList.toggle("active", i === currentPage));
  }

  function refresh() {
    buildDots();
    updateButtons();
    updateDots();
    updateNavVisibility();
  }

  prevBtn.addEventListener("click", () => {
    container.scrollBy({ left: -getPageSize(), behavior: "smooth" });
  });

  nextBtn.addEventListener("click", () => {
    container.scrollBy({ left: getPageSize(), behavior: "smooth" });
  });

  container.addEventListener(
    "scroll",
    () => {
      updateButtons();
      updateDots();
    },
    { passive: true }
  );

  refresh();
  return { refresh, isVisible: () => panel.classList.contains("active") };
}

function initProductCarouselSection(root) {
  const tabs = Array.from(root.querySelectorAll(".rbsv4-product-carousel__tab"));
  const panels = Array.from(root.querySelectorAll(".rbsv4-product-carousel__panel"));
  const carousels = new Map();

  panels.forEach((panel) => {
    carousels.set(panel.dataset.tabPanel, initProductCarousel(panel));
  });

  tabs.forEach((tab) => {
    tab.addEventListener("click", () => {
      const target = tab.dataset.tabTarget;

      tabs.forEach((t) => {
        const active = t === tab;
        t.classList.toggle("active", active);
        t.setAttribute("aria-selected", active ? "true" : "false");
      });

      panels.forEach((panel) => {
        const show = panel.dataset.tabPanel === target;
        panel.classList.toggle("active", show);
        panel.setAttribute("aria-hidden", show ? "false" : "true");
        if (show) {
          const api = carousels.get(target);
          if (api) api.refresh();
        }
      });
    });
  });

  let resizeTimer;
  window.addEventListener("resize", () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(() => {
      carousels.forEach((api) => {
        if (api.isVisible && api.isVisible()) api.refresh();
      });
    }, 200);
  });
}

document.addEventListener("DOMContentLoaded", () => {
  document
    .querySelectorAll(".rbsv4-product-carousel[data-carousel-root]")
    .forEach(initProductCarouselSection);
});
